module.exports = __webpack_public_path__ + "img/logo_pesquisa.608764c1.png";